import React from "react";
import { Content, ContentTitle, ResultText } from "../baseItems";
import Base from "./base";

export default class Papara extends Base {
	getStep1(translate) {
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<ResultText>
					<span>{translate("PAPARA_WARNING")}</span>
				</ResultText>
			</Content>
		);
	}
}
